import LiveCasinoContainer from './live-casino-container'
import connector from './connector'

export default connector(LiveCasinoContainer)
